import Icon from 'veui/components/Icon'
import { IconPlay } from 'dls-icons-vue'

Icon.register('play', IconPlay)
